export default {
  countries: [],
  country: {}
}
